import { render, staticRenderFns } from "./WaScope.vue?vue&type=template&id=e8267676"
import script from "./WaScope.vue?vue&type=script&lang=js"
export * from "./WaScope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports